/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Components, Theme } from "@mui/material/styles";

export const muiTimePickerToolbarStyle = (): Components<Theme>["MuiTimePickerToolbar"] => ({
  styleOverrides: {
    separator: ({ theme }: { theme: Theme }) => theme.typography.h3,
  },
});
